import React, { FC, useState } from 'react';
import { Input, Button } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Form } from '~/components';
import { passwordResetEmailSent, passwordResetTokenExpired } from '~/routes';

import { requestPasswordReset } from '~/api/auth';
import PasswordResetLayout from '~/layout/PasswordResetLayout';

const PasswordResetRequest: FC<RouteComponentProps> = () => {
  const { t } = useTranslation('passwordReset');
  const history = useHistory();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const submit = async (values: any) => {
    const { email } = values;
    try {
      setIsLoading(true);
      await requestPasswordReset(email);
      setIsLoading(false);
      history.push(`/${passwordResetEmailSent}`);
    } catch (error: any) {
      setIsLoading(false);
      history.push(`/${passwordResetTokenExpired}`);
    }
  };

  const [form] = Form.useForm();

  return (
    <PasswordResetLayout
      title={t('Reset password')}
      subtitle={t(
        'Enter the email address associated with your account and we’ll send you a link to reset your password.'
      )}
      withGoToLogin
    >
      <Form
        name="passwordResetRequestForm"
        form={form}
        layout="vertical"
        size="large"
        onFinish={submit}
      >
        <Form.Item name="email" rules={[{ required: true, type: 'email' }]}>
          <Input
            placeholder={t('translation:email')}
            prefix={<UserOutlined />}
            disabled={isLoading}
          />
        </Form.Item>
      </Form>
      <Button
        form="passwordResetRequestForm"
        type="primary"
        htmlType="submit"
        size="large"
        loading={isLoading}
        className="PasswordResetRequest-Button"
      >
        {t('Confirm')}
      </Button>
    </PasswordResetLayout>
  );
};

export default PasswordResetRequest;
